import { useCallback } from "react";

import { ArrowLeft } from "lucide-react";
import { Separator, DefaultTooltip } from "twyne-new.ui";

export default function DefaultVersionHeader({ entityCollection, loading }) {
  const { version: { item, reset }, history: { preview } } = entityCollection || {}
  const { description } = item || {}

  const handleCloseAndReset = useCallback(async () => {
    reset()
  }, [reset])

  if (!item) {
    return null;
  }

  return <div>
    <div className="flex gap-3 justify-center items-center h-full">
      <Separator orientation="vertical" />
      {!preview ? <DefaultTooltip content="Back to default">
        <button className="py-1 twy-text-base hover:twy-text-base-accent cursor-pointer" onClick={handleCloseAndReset} disabled={loading}>
          <ArrowLeft size={20} />
        </button>
      </DefaultTooltip> : null}
      <span className="text-lg twy-text-base">{description}</span>
    </div>
  </div>
}
